import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { isCaktoAnalyticsEnabled } from '@/utils/caktoAnalytics';
import { useAuthContext } from './useAuthContext';

/**
 * Fecha a tela do Cakto Analytics para quem não recebeu a liberação. Mesmo raciocínio do
 * `NfseFeatureGuard`: o campo próprio é recalculado a cada `/user/`, a lista de funções não.
 */
export default function CaktoAnalyticsGuard({ children }) {
  const { user } = useAuthContext();

  if (!isCaktoAnalyticsEnabled(user)) {
    return <Navigate to="/403" replace />;
  }

  return children;
}

CaktoAnalyticsGuard.propTypes = {
  children: PropTypes.node,
};
